import './index.css';

import React from 'react';
import { initSentry } from './sentry';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { App } from 'app/app';

// Before anything renders, so a crash during the first render is still reported.
initSentry();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
